import { render, staticRenderFns } from "./sub-station.vue?vue&type=template&id=0af3ee48"
import script from "./sub-station.vue?vue&type=script&lang=js"
export * from "./sub-station.vue?vue&type=script&lang=js"
import style0 from "./sub-station.vue?vue&type=style&index=0&id=0af3ee48&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports